export const PatientListPageLayoutContextMap = {
  Huddle: 'huddle',
  Claims: 'claims',
  Ambient: 'ambient',
  AutoVerify: 'auto-verify',
  Referrals: 'referrals',
} as const;

export type PatientListPageLayoutContext =
  (typeof PatientListPageLayoutContextMap)[keyof typeof PatientListPageLayoutContextMap];
